export { default as BuyerHome } from './buyer-home'
